<template>
  <div data-cy="tournament-sidebar-container">
    <v-img
      :src="banner"
      class="rounded-te-xl"
      min-height="75px"
      max-height="75px"
      cover
      style="filter: brightness(20%)"
      data-cy="tournament-banner"
    >
    </v-img>
    <div
      style="min-height: 75px; max-height: 75px; margin-top: -75px"
      class="d-flex align-center"
      data-cy="tournament-header"
    >
      <v-avatar rounded="lg" class="mx-4" data-cy="tournament-avatar-container">
        <v-img :src="avatar" data-cy="tournament-avatar-image"></v-img>
      </v-avatar>
      <div class="mr-2" style="z-index: 10" data-cy="tournament-name">
        {{ tournamentStore.tournament?.name }}
      </div>
    </div>
    <div class="mx-2">
      <v-list
        v-model="selected"
        v-model:opened="open"
        mandatory
        open-strategy="single"
        data-cy="event-list"
      >
        <template v-for="event in tournamentStore.tournament?.events" :key="event.id">
          <v-list-item
            :title="event.name"
            :value="event.id"
            :append-icon="selected?.includes(event.id) ? 'mdi-chevron-down' : null"
            :to="generateRoute(event)"
            color="accent"
            rounded="lg"
            :data-cy="`event-item-${event.id}`"
          >
            <template #prepend>
              <v-avatar
                :image="event.videogame.images[0]?.url"
                rounded="lg"
                :data-cy="`event-avatar-${event.id}`"
              >
              </v-avatar>
            </template>

            <template v-if="event.state == 'ACTIVE'" #subtitle>
              <div class="text-success" :data-cy="`event-status-${event.id}`">• In Progress</div>
            </template>
          </v-list-item>
          <div
            v-if="selected?.includes(event.id)"
            class="py-1"
            :data-cy="`event-submenu-${event.id}`"
          >
            <v-list-item
              density="compact"
              rounded="lg"
              :active="$route.name == 'reporting'"
              title="Reporting"
              prepend-icon="mdi-pencil"
              color="accent"
              :to="{
                name: 'reporting',
                params: { tournamentId: tournamentStore.tournament?.id, eventId: event.id }
              }"
              :data-cy="`event-reporting-link-${event.id}`"
            ></v-list-item>
            <v-list-group value="seeding" :data-cy="`event-seeding-group-${event.id}`">
              <template #activator="{ props }">
                <v-list-item
                  v-bind="props"
                  density="compact"
                  rounded="lg"
                  :active="$route.name == 'seeding'"
                  title="Seeding"
                  prepend-icon="mdi-format-list-numbered"
                  color="accent"
                >
                </v-list-item>
              </template>
              <v-list-item
                v-for="phase in event.phases"
                :key="phase.id"
                density="compact"
                rounded="lg"
                :title="phase.name"
                :to="{
                  name: 'seeding',
                  params: {
                    tournamentId: tournamentStore.tournament?.id,
                    eventId: event.id,
                    phaseId: phase.id
                  }
                }"
                :data-cy="`event-seeding-phase-${event.id}-${phase.id}`"
              ></v-list-item>
            </v-list-group>
          </div>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { useEventStore } from '../stores/event'
import { useTournamentStore } from '../stores/tournament'
export default {
  setup() {
    let tournamentStore = useTournamentStore()
    let eventStore = useEventStore()

    return { tournamentStore, eventStore }
  },
  data: () => {
    return {
      open: [],
      selected: []
    }
  },
  computed: {
    avatar() {
      return this.tournamentStore.tournament?.images?.find((image) => image.type === 'profile')?.url
    },
    banner() {
      return this.tournamentStore.tournament?.images?.find((image) => image.type === 'banner')?.url
    }
  },
  watch: {
    '$route.params.eventId'() {
      this.selected = [parseInt(this.$route.params.eventId)]
    },
    '$route.name'() {
      if (this.$route.name) {
        this.open = [this.$route.name]
      }
    }
  },
  mounted() {
    this.selected = [parseInt(this.$route.params.eventId)]
  },
  methods: {
    generateRoute(event) {
      let route = {
        params: {
          tournamentId: this.tournamentStore.tournament.id,
          eventId: event.id
        }
      }

      if (this.$route.name == 'seeding' && event.phases.length) {
        route.name = 'seeding'
        route.params.phaseId = event.phases[0].id
      } else {
        route.name = 'reporting'
      }
      return route
    }
  }
}
</script>
<style></style>
